export default {
  "b2b.provozni-informace-search.widget.label": "Filter",
  "b2b.provozni-informace-search.dateFrom.label": "Date from",
  "b2b.provozni-informace-search.dateTo.label": "Date to",
  "b2b.provozni-informace-search.dateFrom.placeholder": "Enter date from",
  "b2b.provozni-informace-search.dateTo.placeholder": "Enter date to",
  "b2b.provozni-informace-search.button.search": "Search"
};
